import { Text } from "@chakra-ui/react";

function Total({ total }) {
    return <Text fontWeight="600" fontSize="18px" fontFamily="Arial">$ {total}</Text>;
  }
  
  export default Total;
  